const sounds = [
  { category: "Nature", name: "Rain", icon: "rain.svg", src: "rain.mp3" },
  { category: "Nature", name: "Storm", icon: "storm.svg", src: "storm.mp3" },
  { category: "Nature", name: "Wind", icon: "wind.svg", src: "wind.mp3" },
  { category: "Nature", name: "Waves", icon: "waves.svg", src: "waves.mp3" },
  { category: "Nature", name: "Stream", icon: "stream.svg", src: "stream.mp3" },
  { category: "Nature", name: "Birds", icon: "birds.svg", src: "birds.mp3" },
  { category: "Nature", name: "Summer night", icon: "summer-night.svg", src: "summer-night.mp3" },
  { category: "Travel", name: "Train", icon: "train.svg", src: "train.mp3" },
  { category: "Travel", name: "Boat", icon: "boat.svg", src: "boat.mp3" },
  { category: "Travel", name: "City", icon: "city.svg", src: "city.mp3" },
  { category: "Indoors", name: "Coffee shop", icon: "coffee-shop.svg", src: "coffee-shop.mp3" },
  { category: "Indoors", name: "Fireplace", icon: "fireplace.svg", src: "fireplace.mp3" },
  { category: "Noise", name: "Pink noise", icon: "pink-noise.svg", src: "pink-noise.mp3" },
  { category: "Noise", name: "White noise", icon: "white-noise.svg", src: "white-noise.mp3" },
];

export default sounds;